// Apolo IDE — composerGuard (core PURO, sprint composer-anchor E3).
//
// Decide se o envio do composer pode prosseguir, a partir do contexto git
// resolvido + scope + mode. Poka-yoke cirúrgico (NN/g error prevention):
//   - CONFLITO (pref ≠ origin da pasta) → BLOQUEIA. O GuardBanner oferece a
//     resolução nomeada; não há "enviar mesmo assim" escondido.
//   - DIRETO numa branch protegida (main/master/release) → permite, mas pede
//     CONFIRMAÇÃO (escrever na árvore viva da main é irreversível-ish).
//   - unconfirmed (pref sem origin vivo = home antes de clonar) → NÃO bloqueia:
//     é o fluxo normal de abrir um repo. Não gritar lobo à toa.
//
// Puro: sem React/window/store (01-DOCTRINE, arch:core-pure).

/** @typedef {'protected-direct'} ConfirmKind */
/**
 * @typedef {Object} SendVerdict
 * @property {boolean} canSend
 * @property {string|null} blockReason
 * @property {boolean} needsConfirm
 * @property {ConfirmKind|null} confirmKind
 */

/**
 * @param {{ context: import('./gitContext.js').GitContext|null, scope?: string, mode?: string }} input
 * @returns {SendVerdict}
 */
export function evaluateSend(input = {}) {
  const { context = null, mode = 'worktree' } = input;
  if (!context) {
    return { canSend: true, blockReason: null, needsConfirm: false, confirmKind: null };
  }
  if (context.health === 'conflict') {
    return {
      canSend: false,
      blockReason: context.reason || 'O repo selecionado não bate com a pasta da sessão.',
      needsConfirm: false,
      confirmKind: null,
    };
  }
  if (mode === 'direct' && context.protectedBranch) {
    return { canSend: true, blockReason: null, needsConfirm: true, confirmKind: 'protected-direct' };
  }
  return { canSend: true, blockReason: null, needsConfirm: false, confirmKind: null };
}
